import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private _loading = signal<boolean>(false);
  public readonly isLoading = this._loading.asReadonly();
  
  private _globalError = signal<string | null>(null);
  public readonly globalError = this._globalError.asReadonly();

  private loaderDisabled: boolean = false;

  setError(message: string | null): void {
    this._globalError.set(message);
  }

  clearError(): void {
    this._globalError.set(null);
  }

  constructor() {}

  private loadStack: number = 0;

  show() {
    if (this.loaderDisabled) return;
    else {
      this.loadStack++;
      this._loading.set(true);
    }
  }

  hide() {
    if (this.loadStack > 0) {
      this.loadStack--;
    }
    if (this.loadStack === 0) {
      this._loading.set(false);
    }
  }

  disableLoad(): void {
    this.loaderDisabled = true;
    this.loadStack = 0;
    this._loading.set(false);
  }

  enableLoad(): void {
    this.loaderDisabled = false;
  }

  resetSessionState(): void {
    this.loadStack = 0;
    this._loading.set(false);
    this._globalError.set(null);
    this.loaderDisabled = false;
  }
}
